import { useLocation } from '@reach/router';

export const LangEnum = {
  EN: '',
  JA: '/ja',
}

export const Lang = () => {
  const location = useLocation()
  let lang = location.pathname.split("/")[1].replace('/', '')
  return ['ja'].includes(lang) ? LangEnum.JA : LangEnum.EN
}

export const LangCode = () => {
  const location = useLocation()
  let lang = location.pathname.split("/")[1].replace('/', '')
  return ['ja'].includes(lang) ? 'ja' : 'en'
}

export const LangCode2 = () => {
  const location = useLocation()
  let lang = location.pathname.split("/")[1].replace('/', '')
  return ['ja'].includes(lang) ? 'JP' : 'EN'
}


export const InquiryForm = () => {
  const lang = Lang()
  const en = {
    "formName": "Amnet Tour Inquiry Form",
    "tourFieldId0": "TourPackageLists",
    "tourFieldId1": "",
    "tourPeriodId": "TourPeriod"
  }
  const ja = {
    "formName": "Amnet Tour Inqury Form - JP",
    "tourFieldId0": "Tour",
    "tourFieldId1": "OtherTour",
    "tourPeriodId": "TourPeriod_JP"
  }
  return lang === LangEnum.JA ? ja : en
}

// Translations
export const Trans = (key) => {
  const lang = Lang()
  const en = {
    'home': 'Home',
    'menu': 'Menu',
    'japanTours': 'Japan Tours',
    'overview': 'Overview',
    'itinerary': 'Itinerary',
    'accommodations': 'Accommodations',
    'notes': 'Notes',
    'tel': '+1 (646) 770-9043',
    'telLink': 'tel:646-770-9043',
    'viewAll': 'View All',
    'readMore': 'Read more',
    'luxuryVacation': 'Luxury Vacation',
    'details': 'Details',
    'duration': 'Duration',
    'price': 'Price',
    'tourCode': 'Tour Code',
    'tourPeriod': 'Tour Period',
    'day': 'Day',
    'days': 'Days',
    'night': 'Night',
    'nights': 'Nights',
    'checkAvailability': 'Check Availability',
    'included': 'Included',
    'notIncluded': 'Not-Included',
    'additionalInfo': 'Additional Information',

    'footer:japanTours': 'Japan Tours',
    'footer:studyTrips': 'Study Trips',
    'footer:flight': 'Flight',
    'footer:otherServices': 'Other Services',
    'footer:discover': 'Discover',
    'footer:contact': 'Contact',
    'privacyPolicy': 'Privacy Policy',
    'terms&conditions': 'Terms & Conditions',
    'accessibility': 'Accessibility',
  }
  const ja = {
    'home': 'ホーム',
    'menu': 'メニュー',
    'japanTours': '米国発ツアー',
    'overview': 'ツアー概要',
    'itinerary': '旅程',
    'accommodations': 'ホテル',
    'notes': '注意事項など',
    'tel': '+1 (800) 929 - 2663',
    'telLink': 'tel:800-929-2663',
    'viewAll': '全てを表示',
    'readMore': '続きを読む',
    'luxuryVacation': 'バケーション',
    'details': '詳細',
    'duration': '旅行期間',
    'day': '日',
    'days': '日',
    'night': '泊',
    'nights': '泊',
    'price': '料金',
    'tourCode': 'ツアーコード',
    'tourPeriod': '催行日',
    'checkAvailability': 'お問い合わせ',
    'included': '含まれるもの',
    'notIncluded': '含まれないもの',
    'additionalInfo': 'ツアー条件',

    'footer:japanTours': 'バケーション',
    'footer:studyTrips': '法人のお客さま',
    'footer:flight': '航空券',
    'footer:otherServices': 'その他サービス',
    'footer:discover': '体験談・お役立ち情報',
    'footer:contact': 'お問い合わせ',
    'privacyPolicy': '個人情報保護',
    'terms&conditions': 'サイト規約',
    'accessibility': 'アクセシビリティ',
  }
  return (lang === LangEnum.JA ? ja[key] : en[key]) || key
}
